import { green, red, orange } from '@mui/material/colors';

export const appointments = [ 
];

export const priorities = [
  { text: 'Prioridad Baja', id: 1, color: green },
  { text: 'Prioridad Media', id: 2, color: orange },
  { text: ' Prioridad Alta', id: 3, color: red },
];

export const projects = [
  {
    text: 'Proyecto 1',
    id: 1,
    color: '#7E57C2',
  }, {
    text: 'Proyecto 2',
    id: 2,
    color: '#FF7043',
  }, {
    text: 'Proyecto 3',
    id: 3,
    color: '#E91E63',
  },
];


  